class Block {
  constructor(block) {
    this.el = $(block);

    if (this.el.data('refreshId')) {
      this.reload();
    }
  }

  reload() {
    $.ajax({
      url: window.bvm.ajax,
      method: 'POST',
      data: {
        action: 'bvm_blocks_ad_registration_refresh',
        id: this.el.data('refreshId'),
      },
    })
    .done(response => {
      if (response.success) {
        $(response.data)
        .find('[data-refresh]')
        .each((i, temp) => this.el.find(`[data-refresh="${temp.dataset.refresh}"]`).replaceWith(temp));
      }
    })
    .fail(error => {
      console.error(error);
    });
  }
}

class AdRegistration {
  constructor(document = window.document) {
    this.blocks = document.querySelectorAll('[data-block="ad-registration"]');

    if (0 !== this.blocks.length) {
      this.blocks.forEach(block => {
        new Block(block);
      });
    }
  }
}

new AdRegistration();

$(document).on('bvm_blocks_ad-registration_init', (event, document) =>  {
  if ('function' === typeof document.querySelectorAll) {
    new AdRegistration(document);
  }
})
